import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { combineLatest, map, Subscription } from 'rxjs';
import { setPumpUnitValue } from '../../../display-product-data/store/pump-system/pump-system.actions';
import { setPumpUnitDrawing, setPumpUnitDrawingUrl, setPumpUnitItem, setPumpUnitMaxTemp, setPumpUnitPicture, setPumpUnitPictureUrl, setPumpUnitSuctionHead } from '../../../display-product-data/store/pump-unit/pump-unit.actions';
import { PumpUnitState } from '../../../display-product-data/store/pump-unit/pump-unit.reducer';
import { selectPumpUnit } from '../../../display-product-data/store/pump-unit/pump-unit.seletor';

@Component({
    selector: 'app-pump-unit-select',
    templateUrl: './pump-unit-select.component.html',
    styleUrls: ['./pump-unit-select.component.scss'],
    standalone: false
})
export class PumpUnitSelectComponent implements OnInit, OnDestroy {

  private pumpUnitChange!: Subscription;
  pumpUnitForm!: FormGroup;

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
  ) {
    this.pumpUnitForm = this.formBuilder.group({
      item: [''],
      maxTemp: [''],
      suctionHead: [''],
      drawing: [''],
      drawing_url: [''],
      picture: [''],
      picture_url: ['']
    });
  }

  ngOnInit(): void {
    console.log('PumpUnitSelectComponent initialized');
    this.pumpUnitChange = combineLatest([
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.item)
      ),
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.maxTemp)
      ),
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.suctionHead)
      ),
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.drawing)
      ),
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.picture)
      ),
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.drawing_url)
      ),
      this.store.pipe(
        select(selectPumpUnit),
        map((data: PumpUnitState) => data.picture_url)
      )
    ]).subscribe(([item, maxTemp, suctionHead, drawing, picture, drawing_url, picture_url]) => {
      //this is because we introducted drawing and picture url in pump unit but we want to keep the old drawing and picture field for backward compatibility, 
      // so if drawing url is available we will use it to extract the name and set it to drawing field, if not we will use the old drawing field, same for picture  
      if(picture && picture!== '' && (!drawing || drawing === '')) {
      drawing? drawing = drawing : drawing = picture;
      this.store.dispatch(setPumpUnitDrawing({ data: drawing }));
      }
      this.pumpUnitForm.patchValue({
        item,
        maxTemp,
        suctionHead,
        drawing,
        picture,
        drawing_url,
        picture_url
      }, { emitEvent: false });
    

    
      this.store.dispatch(setPumpUnitValue({ data: {
        item,
        maxTemp,
        suctionHead,
        drawing,
        picture,
        drawing_url,
        picture_url
        
      } }));
       
    });
    console.log('PumpUnitSelectComponent subscription set up');
  }

  onInput(value: string, type: string) {
    switch(type) {
      case 'item':
        this.pumpUnitForm.get('item')!.setValue(value);
        this.store.dispatch(setPumpUnitItem({ data: value }));
        this.store.dispatch(setPumpUnitValue({ data: { item: value } }));
        break;
      case 'maxTemp':
        this.pumpUnitForm.get('maxTemp')!.setValue(value);
        this.store.dispatch(setPumpUnitMaxTemp({ data: value }));
        this.store.dispatch(setPumpUnitValue({ data: { maxTemp: value } }));
        break;
      case 'drawing':
        this.pumpUnitForm.get('drawing')!.setValue(value);
        this.store.dispatch(setPumpUnitDrawingUrl({ data: value }));
        this.store.dispatch(setPumpUnitDrawing({ data: this.extractNameFromUrl(value) }));
        this.store.dispatch(setPumpUnitValue({ data: { drawing_url: value } }));
        this.store.dispatch(setPumpUnitValue({ data: { drawing: this.extractNameFromUrl(value) } }));
        break;
      case 'picture':
        this.pumpUnitForm.get('picture')!.setValue(value);
        this.store.dispatch(setPumpUnitPicture({ data: this.extractNameFromUrl(value) }));
        this.store.dispatch(setPumpUnitPictureUrl({ data: value }));
        this.store.dispatch(setPumpUnitValue({ data: { picture_url: value } }));
        this.store.dispatch(setPumpUnitValue({ data: { picture: this.extractNameFromUrl(value) } }));
        break;

      default:
        this.pumpUnitForm.get('suctionHead')!.setValue(value);
        this.store.dispatch(setPumpUnitSuctionHead({ data: value }));
        this.store.dispatch(setPumpUnitValue({ data: { suctionHead: value } }));
    }
  }

  onDrawingSelect(event: any) {
    const drawingUrl = event.value;
    const drawingName = this.extractNameFromUrl(drawingUrl);
    this.pumpUnitForm.patchValue({
      drawing: drawingName,
      drawing_url: drawingUrl
    }, { emitEvent: false });
    this.store.dispatch(setPumpUnitDrawingUrl({ data: drawingUrl }));
    this.store.dispatch(setPumpUnitDrawing({ data: drawingName })); 
    }

  onPictureSelect($event: any) {
    const pictureUrl = $event.value;
    const pictureName = this.extractNameFromUrl(pictureUrl);
    this.pumpUnitForm.patchValue({
      picture: pictureName,
      picture_url: pictureUrl
    }, { emitEvent: false });
    this.store.dispatch(setPumpUnitPictureUrl({ data: pictureUrl }));
    this.store.dispatch(setPumpUnitPicture({ data: pictureName }));
  }

  private extractNameFromUrl(value: string): string {
    if (!value) return '';
    // If it's a URL, extract the name
    if (value.includes('http') || value.includes('s3')) {
      const nameMatch = value.match(/\/([^\/]+)\.[^\/]+$/);
      return nameMatch ? nameMatch[1] : value;
    }
    // Otherwise it's already a name
    return value;
  }

  ngOnDestroy() {
    if (this.pumpUnitChange) {
      this.pumpUnitChange.unsubscribe();
    }
  }
}
